import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, FileText, ShieldCheck } from "lucide-react";
import { Footer } from "./Footer";
import { config } from "../config";
import documents from "../data/legal.json";
import "./legal.css";

export function LegalPage({ kind }) {
  const doc = documents[kind];
  const privacy = kind === "privacy";
  const Icon = privacy ? ShieldCheck : FileText;
  useEffect(() => {
    if (window.location.hash) {
      requestAnimationFrame(() => document.getElementById(window.location.hash.slice(1))?.scrollIntoView());
    } else window.scrollTo(0, 0);
  }, [doc.title]);
  return (
    <div className="min-h-screen bg-[#FAFBFD] text-slate-900 antialiased">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-5 sm:px-8">
          <Link to="/" className="text-xl font-medium" style={{ fontFamily: "'Outfit', sans-serif" }}>Pro360<span className="ml-2 text-sm text-[#4F5BD5]">Plus</span></Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-indigo-700"><ArrowLeft size={16} /> Volver al inicio</Link>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-5 pb-20 pt-12 sm:px-8 sm:pt-16">
        <div className="max-w-3xl">
          <Icon className="mb-5 h-8 w-8 text-[#4F5BD5]" strokeWidth={1.5} />
          <p className="text-sm font-medium text-[#4F5BD5]">Pro 360 E.A.S.</p>
          <h1 className="mt-3 text-3xl font-medium leading-tight sm:text-5xl" style={{ fontFamily: "'Outfit', sans-serif" }}>{doc.title}</h1>
          {doc.updated && <p className="mt-4 text-sm text-slate-500">{doc.updated}</p>}
        </div>
        <div className="mt-10 grid items-start gap-10 border-t border-slate-200 pt-8 lg:grid-cols-[240px_minmax(0,1fr)] lg:gap-16">
          <aside className="lg:sticky lg:top-8">
            <nav aria-label="Contenido de esta página" className="space-y-1">
              {doc.sections.map((section) => <a key={section.id} href={`#${section.id}`} className="block rounded-md px-2 py-2 text-sm leading-relaxed text-slate-600 hover:bg-indigo-50 hover:text-indigo-700">{section.title}</a>)}
            </nav>
            <Link to={privacy ? config.links.terms : config.links.privacy} className="mt-5 inline-flex items-center gap-2 border-t border-slate-200 pt-5 text-sm font-medium text-[#4F5BD5]">
              {privacy ? "Condiciones de servicio" : "Política de privacidad"}<ArrowUpRight size={16} />
            </Link>
          </aside>
          <article className="legal-copy min-w-0 max-w-3xl">
            <div dangerouslySetInnerHTML={{ __html: doc.intro }} />
            {doc.sections.map((section) => <section id={section.id} key={section.id} className="scroll-mt-8">
              <h2>{section.title}</h2><div dangerouslySetInnerHTML={{ __html: section.html }} />
            </section>)}
            {doc.footer && <div className="mt-10 border-t border-slate-200 pt-5" dangerouslySetInnerHTML={{ __html: doc.footer }} />}
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
}
